import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/dahg79joh653ivfvnu4g';

const materialOptions = ['录音', '视频证据', '合同照片', '转账记录', '其他材料'];

export default function SubmitForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('website_alt') ?? '').trim();
    if (honeypot) {
      setStatus('success');
      setFormError('');
      form.reset();
      return;
    }
    formData.delete('website_alt');

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      params.append(key, String(value));
    });

    setStatus('submitting');
    setFormError('');

    try {
      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试。';
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');

      if (response.ok && code === 'OK' && !isSpam) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(isSpam ? '提交未通过校验，请确认填写内容后重试。' : String(serverMsg));
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，提交失败，请稍后重试。');
    }
  }

  const inputClass =
    'w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400';

  return (
    <form onSubmit={handleSubmit} data-readdy-form className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="name" className="mb-1.5 block text-sm text-foreground-700">
            怎么称呼你
          </label>
          <input id="name" name="name" type="text" required placeholder="可用网名或化名" className={inputClass} />
        </div>
        <div>
          <label htmlFor="email" className="mb-1.5 block text-sm text-foreground-700">
            联系邮箱
          </label>
          <input id="email" name="email" type="email" required placeholder="用于核对材料，不会公开" className={inputClass} />
        </div>
      </div>

      <div className="mt-4">
        <label htmlFor="material_type" className="mb-1.5 block text-sm text-foreground-700">
          主要材料类型
        </label>
        <select id="material_type" name="material_type" required defaultValue="" className={`${inputClass} cursor-pointer`}>
          <option value="" disabled>
            请选择一种主要材料
          </option>
          {materialOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-4">
        <label htmlFor="summary" className="mb-1.5 block text-sm text-foreground-700">
          事件简述
        </label>
        <textarea
          id="summary"
          name="summary"
          required
          maxLength={500}
          rows={5}
          placeholder="简单说明事情的经过、涉及的关键时间点，以及你手上有哪些材料（500 字以内）"
          className={`${inputClass} resize-none`}
        ></textarea>
        <p className="mt-1 text-xs text-foreground-500">为避免隐私泄露，请勿在此填写身份证号、银行卡号等敏感信息。</p>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="contact-verify-field"
      />

      {status === 'error' && formError && (
        <p className="mt-4 flex items-start gap-2 rounded-md bg-primary-50 px-3 py-2 text-sm text-primary-700">
          <i className="ri-error-warning-line mt-0.5"></i>
          {formError}
        </p>
      )}
      {status === 'success' && (
        <p className="mt-4 flex items-start gap-2 rounded-md bg-secondary-100 px-3 py-2 text-sm text-secondary-900">
          <i className="ri-checkbox-circle-line mt-0.5"></i>
          材料已提交，我们会在 2 个工作日内通过邮箱与你联系，请留意收件箱。
        </p>
      )}

      <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs leading-relaxed text-foreground-500">提交即表示你确认材料来源真实，并同意我们按展示规范进行脱敏处理。</p>
        <button
          type="submit"
          disabled={status === 'submitting'}
          className="whitespace-nowrap rounded-md bg-primary-600 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === 'submitting' ? '正在提交…' : '提交材料'}
        </button>
      </div>
    </form>
  );
}